"use strict";

const minisFancyContainer = document.querySelector(".minis-fancy");
if (minisFancyContainer) {
  const overlayElement = minisFancyContainer.querySelector(".overlay");
  minisFancyContainer.addEventListener("mouseover", () => {
    overlayElement.classList.add("opacity-50");
  });
  minisFancyContainer.addEventListener("mouseleave", () => {
    overlayElement.classList.remove("opacity-50");
  });
  const showImage = elm => {
    const elementsAbove = [elm];
    let prevElement = elm.previousElementSibling;
    while (prevElement) {
      elementsAbove.push(prevElement);
      prevElement = prevElement.previousElementSibling;
    }
    const elementsBelow = [];
    let nextElement = elm.nextElementSibling;
    while (nextElement) {
      elementsBelow.push(nextElement);
      nextElement = nextElement.nextElementSibling;
    }
    elementsBelow.forEach(elm => elm.classList.remove("opacity-100"));
    elementsAbove.forEach(elm => elm.classList.add("opacity-100"));
  };
  const items = minisFancyContainer.querySelectorAll(".mini-fancy");
  items.forEach(item => {
    const image = minisFancyContainer.querySelector(".".concat(item.getAttribute("image")));
    item.addEventListener("mouseover", () => {
      showImage(image);
    });
  });
}
//# sourceMappingURL=minisFancy.js.map